export enum SetupAppName {
    FIELD = "cdp_my",
}